//
// # Core Utils Namespace
//

export { exhaust } from "./exhaust";

export * as params from "./params";
export { paramValueToString } from "./params";

export * as result from "./result";
export { Result, AsyncResult, Ok, Err } from "./result";

export * as validate from "./validate";
export { Validator, type InnerValidator } from "./validate";

export * as gitinfo from "./gitinfo";
export { GitInfo } from "./gitinfo";

export * as uuid from "./uuid";
export { Uuid, UuidMap } from "./uuid";

export * as change from "./change";
export * from "./change";

export * as requests from "./requests";
export { Requests, type Error as RequestsError } from "./requests";

export * as msgs from "./messages";
export * as messages from "./messages";
export {
  Message,
  ToEditor as MessageToEditor,
  ToPlatform as MessageToPlatform,
  Kind as MessageKind,
  LoadKind,
} from "./messages";

export * as msgserver from "./msgserver";
export { MessageServer, type MessageError } from "./msgserver";

export { ConsoleLogger, logger, LogLevel } from "./logger";
export type { Logger } from "./logger";

export * as context from "./context";
export {
  Context,
  CTX_LOG_ID,
  CTX_REQUEST_ID,
  CTX_USER,
  CTX_TENANT,
  CTX_ENV,
  CTX_SESSION_ID,
  CTX_START_TIME,
  CTX_COMMIT_HASH,
  // Context factory functions
  generateLogId,
  createRequestContext,
  createBackgroundContext,
} from "./context";
export type { ContextWire, ContextOptions } from "./context";

export * as gcp_log from "./gcp_log";
export {
  gcpLogsUrl,
  formatGcpLogMessage,
  shouldLogApi,
  isPing,
  LogKind,
  checkpoint,
  FILTERED_APIS,
} from "./gcp_log";

export * as reconnect from "./reconnect";
export { ReconnectionManager, type ReconnectionConfig } from "./reconnect";

export * as crdt from "./crdt";
export {
  // Timestamp types and functions
  type LamportTimestamp,
  compareTimestamp,
  maxTimestamp,
  createInitialTimestamp,
  tickTimestamp,
  receiveTimestamp,
  // CRDT Entity types and functions
  type CRDTEntity,
  createCRDTEntity,
  deleteCRDTEntity,
  mergeCRDTEntities,
  // CRDT Operation types
  type CRDTOp,
  type CRDTChangesRequest,
  type CRDTChangesResponse,
  type CRDTConfig,
  DEFAULT_CRDT_CONFIG,
} from "./crdt";
